import { Box } from "@mui/material";
import QAL3Report from "../components/reports/qal3Report/QAL3Report";
import AutoZeroReport from "../components/reports/autozeroReport/AutoZeroReport";
import React from "react";
import { useReportsConfig } from "../hooks/useReduxSelectors";
import EdgeUnitStatusPanel from "../components/edgeUnitStatusPanel/EdgeUnitStatusPanel";
import EnergiesReport from "../components/reports/energiesReport/EnergiesReport";
import SteamtrapReport from "../components/reports/steamtrapReport/SteamtrapReport";

const ReportsContainer = ({ systemName }) => {
  const reportsConfig = useReportsConfig();

  return (
    <Box sx={{ height: "100%", overflow: "auto" }}>
      {reportsConfig && reportsConfig?.AutoZero && <AutoZeroReport systemName={systemName} />}
      {reportsConfig && reportsConfig?.QAL3 && <QAL3Report systemName={systemName} />}
      {reportsConfig && reportsConfig?.energy && <EnergiesReport energyReportType="Day" systemName={systemName} />}
      {reportsConfig && reportsConfig?.energy && <EnergiesReport energyReportType="Month" systemName={systemName} />}
      {reportsConfig && reportsConfig?.steamtrap && <SteamtrapReport systemName={systemName} />}
    </Box>
  );
};

export default ReportsContainer;
